
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Crear panel de control',
	'dashboard': 'Panel de control',
	'dashboardTemplate': 'Plantilla de panel de control',
	'createAV': 'Crear',
	'createAvEditNameLabel': '1. Dé nombre a la vista',
	'createAvSelectTemplateLabel': '2. Seleccione una plantilla',
	'tabLayoutLabel': 'Plantilla con pestañas',
	'infographicsLayoutLabel': 'Plantilla infográfica',
	'singlePageLayoutLabel': 'Plantilla de página única',
	'customLayoutLabel': 'Plantilla personalizada',
	'freeformTemplate': 'Formato libre',
	'freeformTemplateDesc': 'Las visualizaciones en un diseño de formato libre aparecen exactamente con el tamaño y la ubicación que les ha dado en la vista, independientemente del tamaño de la pantalla. En otros diseños, el tamaño y la posición de las visualizaciones se ajustan a la pantalla.',
	'NoTemplate': 'Formato libre',
	'Template1': 'Blanco',
	'Template2': 'Título 1 por 2',
	'Template3': '2 sobre 1',
	'Template4': '4 sobre 1',
	'Template5': 'Pie de página 1 por 2',
	'Template6': '3 junto a 1 sobre 1',
	'Template7': '4 junto a 3 sobre 1',
	'Template8': '2 sobre 3 por 2',
	'Template9': '2 por 2',
	'Template10': '1 por 2 junto a 2 por 2 sobre 1',
	'Template11': '3 por 1 sobre 1 por 2',
	'Template12': '2 sobre 1 junto a 1 por 2',
	'Template13': 'Uno junto a 1 por 2 junto a 1 por 4',
	'Template22': '1 sobre 2 por 2',
	'Template14': '1 junto a 1',
	'Template15': '1 sobre 1 junto a 1',
	'Template16': '1 junto a 1 sobre 1',
	'Template17': '1 sobre 1 junto a 1 sobre 1',
	'Template18': '1 sobre 1 junto a 1',
	'Template19': '1 sobre 2 junto a 1',
	'Template20': '1 sobre 2 por 1',
	'Template21': '1 sobre 1 sobre 2 por 1',
	'Template23': 'En blanco con zona de colocación',
	'Infographics1': 'Blanco',
	'Infographics2': '4 filas',
	'Infographics3': '4 filas con cabeceras',
	'Infographics4': '2 por 4',
	'Infographics5': 'Visualización superior grande con 2 por 2',
	'Infographics6': '2 por 4 con espacio vertical',
	'Infographics7': '2 por 4 con escalonado',
	'Infographics8': 'Pista de tenis',
	'Infographics9': '3 por 4',
	'Infographics10': '4 por 8',
	'createAvDashboardLabel': 'Diseño',
	'dashboard_template_save_success': 'Se ha guardado la plantilla de su panel de control.',
	'dashboard_template_prefix': 'Plantilla: "%{name}"',
	'dashboard_template_filters_removed': 'Los filtros del lienzo se han eliminado.',
	'createAvTabLabel': 'Con pestañas',
	'createAvInfographicsLabel': 'Infografía',
	'createAvSinglepageLabel': 'Una sola página',
	'createAvCustomLabel': 'Personalizado',
	'loadMoreLabel': 'Cargar más...',
	'backLabel': 'Retroceder',
	'addSourceLabel': 'Añadir un origen',
	'pinLabel': 'Anclar',
	'errorLoadingDataSetMetaData': 'Se ha producido un error al leer los metadatos',
	'errorLoadingDataSets': 'Se ha producido un error al cargar la lista de conjuntos de datos',
	'errorLoadingDataSet': 'Los metadatos del conjunto de datos "%{datasetName}" no se han cargado. Póngase en contacto con el administrador para obtener información detallada.',
	'okButton': 'Aceptar',
	'createButton': 'Crear',
	'cancelButton': 'Cancelar',
	'copyButton': 'Copiar',
	'selectTemplateLabel': 'Seleccionar una plantilla',
	'createBoardTitle': 'Crear un panel de control',
	'createBoardSubtitle': 'Seleccione una plantilla para el panel de control',
	'noSourcesSelectedLabel': 'No se ha seleccionado ningún origen',
	'find_label': 'Buscar',
	'noDashboardFound': 'El panel de control no se puede recuperar. Es posible que ya no exista o que no tiene suficientes privilegios para visualizarla.',
	'errorLabel': 'Error',
	'defaultName': 'Nuevo cuadro de mandos',
	'noDashboardCapability': 'No dispone de la capacidad para ejecutar la aplicación del panel de control',
	'noDashboardPermission': 'No tiene privilegios suficientes para ver este panel de control.',
	'sourceNotFound': 'No podemos cargar la visualización porque el origen asociado "%{sourceName}" no está disponible.',
	'cmDuplicateName': 'Ya existe un elemento con este nombre. Pruebe otro nombre',
	'cmEmptySelection': 'Se ha suprimido el panel de control. Intente guardarlo como un nuevo panel de control.',
	'propTheme': 'Tema visual',
	'legacyThemeLabel': 'Heredada',
	'carbonGrey10Label': 'Copia X claro',
	'carbonGrey100Label': 'Copia X oscuro',
	'titleTextLabel': 'Título',
	'titleSmallTextLabel': 'Título pequeño',
	'subtitleTextLabel': 'Subtítulo',
	'bodyTextLabel': 'Cuerpo',
	'bodySmallTextLabel': 'Cuerpo pequeño',
	'captionTextLabel': 'Título',
	'quoteTextLabel': 'Cita',
	'quoteSmallTextLabel': 'Cita pequeña',
	'responsiveTextLabel': 'Tamaño automático',
	'mediaWidgetLabel': 'Multimedia',
	'webpageWidgetLabel': 'Página web',
	'imageWidgetLabel': 'Imagen',
	'textWidgetLabel': 'Texto',
	'notebookWidgetLabel': 'Notebook',
	'multipurposeWidgetLabel': 'Finalidad múltiple',
	'textPlaceHolder': 'Pulse para editar el texto',
	'titlePlaceHolder': 'Pulse para editar el título',
	'toggleEditModeLabel': 'Cambiar a editar',
	'togglePreviewModeLabel': 'Cambiar a vista previa',
	'editDashboardCoachMarkTitle': 'Editar panel de control',
	'editDashboardCoachMarkContents': 'Pulse el icono del lápiz para editar este panel de control.',
	'addDataCoachMarkTitle': 'Añadir datos',
	'addDataDashboardCoachMarkContents': 'Arrastre los datos del panel de datos y suéltelos en el panel de control.',
	'pageSelectWarning': 'Seleccione una pestaña.',
	'screenshot_label': 'Panel de control %{title}',
	'screenshot_label_tab': 'Pestaña %{tabName} del panel de control %{title}',
	'dataAssetPropertiesLabel': 'Propiedades de visualización',
	'modelFilter': 'Filtro',
	'invertSelectionToolTip': 'Invertir selecciones del filtro',
	'clearFilterValueToolTip': 'Borrar valores del filtro',
	'invertFilterSelection': 'Invertir',
	'clearTextFilterValue': 'Borrar',
	'filterConditionLabel': 'Filtrar condición',
	'applyFilter': 'Aplicar filtro',
	'itemCountText': '%{itemCount} elemento(s) seleccionado(s)',
	'itemExcludeCountText': '%{itemCount} elemento(s) excluido(s)',
	'moreMembers': 'Mostrar más...',
	'searchHierarchyMembers': 'Utilizar búsqueda para encontrar miembros...',
	'propHideEmpty': 'Ocultar vacío',
	'propColorOrder': 'Orden de colores',
	'propElementColor': 'Color de elemento de visualización',
	'propLineColor': 'Color de línea',
	'propLineAndSymbolColor': 'Color de línea y símbolo',
	'propColumnColor': 'Color de columnas',
	'propBarColor': 'Color de barra',
	'propWordColor': 'Color de palabras',
	'propAreaColor': 'Color de área',
	'propRadialbarColor': 'Color de barra radial',
	'propColorPalettes': 'Paletas de colores',
	'propDashboardColorPalette': 'Paleta de panel de control actual',
	'propNewDashboardPaletteLabel': 'Crear una paleta de panel de control personalizada',
	'propDashboardChangePaletteLink': 'Cambiar paleta de panel de control',
	'propHideLeafNode': 'Ocultar etiquetas iniciales',
	'propOpacity': 'Opacidad',
	'propOpacityDescription': 'Hacer que el objeto sea más o menos opaco. Especifique un valor entre 0 y 100',
	'addATab': 'Añadir una nueva pestaña',
	'propFredIsRed': 'Consistencia de color',
	'areaChartCaption': 'Área',
	'areaChartDataSlot_categoriesLabel': 'Etiqueta de eje',
	'areaChartDataSlot_valuesLabel': 'Valor',
	'areaChartProp_colorPaletteLabel': 'Paletas de colores',
	'areaChartProp_lineColorLabel': 'Color de área',
	'areaChartProp_interpolationLabel': 'Líneas suavizadas',
	'areaChartProp_interpolationDescription': 'Las líneas que conectan los puntos de datos son curvas.',
	'areaChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'areaChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'areaChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'areaChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'areaChartProp_suppressZerosLabel': 'Ocultar vacío',
	'areaChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'barChartCaption': 'Barra',
	'barChartDataSlot_categoriesLabel': 'Etiqueta de eje',
	'barChartDataSlot_valuesLabel': 'Valor',
	'barChartProp_colorPaletteLabel': 'Paletas de colores',
	'barChartProp_elementColorLabel': 'Color de barra',
	'barChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'barChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'barChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'barChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'barChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'barChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'barChartProp_suppressZerosLabel': 'Ocultar vacío',
	'barChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'columnChartCaption': 'Columna',
	'columnChartDataSlot_categoriesLabel': 'Etiqueta de eje',
	'columnChartDataSlot_valuesLabel': 'Valor',
	'columnChartProp_colorPaletteLabel': 'Paletas de colores',
	'columnChartProp_elementColorLabel': 'Color de columnas',
	'columnChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'columnChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'columnChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'columnChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'columnChartProp_suppressZerosLabel': 'Ocultar vacío',
	'columnChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'bubbleChartCaption': 'Burbuja',
	'bubbleChartDataSlot_xAxisLabel': 'Eje horizontal',
	'bubbleChartDataSlot_yAxisLabel': 'Eje vertical',
	'bubbleChartDataSlot_sizeLabel': 'Aplicar tamaño',
	'bubbleChartDataSlot_colorLabel': 'Aplicar color',
	'bubbleChartProp_colorPaletteLabel': 'Paletas de colores',
	'bubbleChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'bubbleChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'bubbleChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'bubbleChartProp_hideLegendLabel': 'Ocultar leyenda',
	'bubbleChartProp_hideLegendDescription': 'Ocultar la leyenda.',
	'bubbleChartProp_legendPositionLabel': 'Posición de la leyenda',
	'lineChartCaption': 'Línea',
	'lineChartDataSlot_categoriesLabel': 'Etiqueta de eje',
	'lineChartDataSlot_valuesLabel': 'Valor',
	'lineChartProp_colorPaletteLabel': 'Paletas de colores',
	'lineChartProp_lineColorLabel': 'Color de línea y símbolo',
	'lineChartProp_symbolShapeLabel': 'Forma del símbolo',
	'lineChartProp_hideSymbolsLabel': 'Ocultar símbolos',
	'lineChartProp_hideSymbolsDescription': 'Ocultar símbolos',
	'lineChartProp_hideDataLinesLabel': 'Ocultar línea(s)',
	'lineChartProp_hideDataLinesDescription': 'Ocultar línea(s)',
	'lineChartProp_interpolationLabel': 'Líneas suavizadas',
	'lineChartProp_interpolationDescription': 'Las líneas que conectan los puntos de datos son curvas.',
	'lineChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'lineChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'lineChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'lineChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'lineChartProp_suppressZerosLabel': 'Ocultar vacío',
	'lineChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'packedBubbleChart1CatCaption': 'Burbuja empaquetada',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categorías',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Aplicar tamaño',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Paletas de colores',
	'packedBubbleChart1CatProp_elementColorLabel': 'Color de burbuja',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Ocultar etiqueta',
	'packedBubbleChart1CatProp_hideValueLabel': 'Ocultar valor',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Ocultar vacío',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'heatChartCaption': 'Uso crítico',
	'heatChartDataSlot_valuesLabel': 'Uso crítico por',
	'heatChartDataSlot_xAxisLabel': 'Eje horizontal',
	'heatChartDataSlot_yAxisLabel': 'Eje vertical',
	'heatChartProp_colorPaletteLabel': 'Paletas de colores',
	'heatChartProp_heatScalePaletteLabel': 'Orden de colores',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'heatChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'heatChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'heatChartProp_suppressZerosLabel': 'Ocultar vacío',
	'heatChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'heatChartProp_hideLegendLabel': 'Ocultar leyenda',
	'heatChartProp_hideLegendDescription': 'Ocultar la leyenda.',
	'heatChartProp_legendPositionLabel': 'Posición de la leyenda',
	'pieChartCaption': 'Circular',
	'pieChartDataSlot_categoriesLabel': 'Categorías',
	'pieChartDataSlot_valuesLabel': 'Valor',
	'pieChartProp_colorPaletteLabel': 'Paletas de colores',
	'pieChartProp_hideRadialValueLabel': 'Ocultar valor',
	'pieChartProp_pieAsDonutLabel': 'Mostrar como diagrama de anillo',
	'pieChartProp_pieAsDonutDescription': 'Mostrar como diagrama de anillo',
	'pieChartProp_suppressZerosLabel': 'Ocultar vacío',
	'pieChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'pieChartProp_hideLegendLabel': 'Ocultar leyenda',
	'pieChartProp_hideLegendDescription': 'Ocultar la leyenda.',
	'pieChartProp_legendPositionLabel': 'Posición de la leyenda',
	'map1measureCaption': 'Mapa',
	'map1measureDataSlot_categoriesLabel': 'Regiones',
	'map1measureDataSlot_valuesLabel': 'Uso crítico de región',
	'map1measureProp_colorPaletteLabel': 'Paletas de colores',
	'map1measureProp_heatScalePaletteLabel': 'Orden de colores',
	'map1measureProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'map1measureProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'map1measureProp_suppressZerosLabel': 'Ocultar vacío',
	'map1measureProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'map1measureProp_hideLegendLabel': 'Ocultar leyenda',
	'map1measureProp_hideLegendDescription': 'Ocultar la leyenda.',
	'map1measureProp_legendPositionLabel': 'Posición de la leyenda',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Categorías',
	'radialChartDataSlot_valuesLabel': 'Valor',
	'radialChartProp_colorPaletteLabel': 'Paletas de colores',
	'radialChartProp_elementColorLabel': 'Color de barra radial',
	'radialChartProp_hideRadialTitleLabel': 'Ocultar título',
	'radialChartProp_hideRadialValueLabel': 'Ocultar valor',
	'radialChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'radialChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'radialChartProp_suppressZerosLabel': 'Ocultar vacío',
	'radialChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'pointChart1catCaption': 'Puntos',
	'pointChart1catDataSlot_valuesLabel': 'Valor',
	'pointChart1catDataSlot_categoriesLabel': 'Etiqueta de eje',
	'pointChart1catProp_colorPaletteLabel': 'Paletas de colores',
	'pointChart1catProp_elementColorLabel': 'Color de forma',
	'pointChart1catProp_symbolShapeLabel': 'Forma del símbolo',
	'pointChart1catProp_symbolFillLabel': 'Forma de relleno',
	'pointChart1catProp_symbolFillDescription': 'Mostrar color de relleno para los símbolos.',
	'pointChart1catProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'pointChart1catProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'pointChart1catProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'pointChart1catProp_suppressZerosLabel': 'Ocultar vacío',
	'pointChart1catProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'scatterPlotChartNoCatCaption': 'Diagrama de dispersión',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Eje horizontal',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Eje vertical',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Paletas de colores',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Color de elementos',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Forma del símbolo',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Forma de relleno',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Mostrar color de relleno para los símbolos.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'radialBarChartCaption': 'Barra radial',
	'radialBarChartDataSlot_categoriesLabel': 'Categorías',
	'radialBarChartDataSlot_valuesLabel': 'Valor',
	'radialBarChartProp_colorPaletteLabel': 'Paletas de colores',
	'radialBarChartProp_elementColorLabel': 'Color de barra radial',
	'radialBarChartProp_hideRadialTitleLabel': 'Ocultar título',
	'radialBarChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'radialBarChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'radialBarChartProp_suppressZerosLabel': 'Ocultar vacío',
	'radialBarChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'lineColumnComboChartCaption': 'Línea y columna',
	'lineColumnComboChartDataSlot_categoryLabel': 'Etiqueta de eje',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Valor de línea',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Valor de columna',
	'lineColumnComboChartProp_colorPaletteLabel': 'Paletas de colores',
	'lineColumnComboChartProp_elementColorLabel': 'Color de columnas',
	'lineColumnComboChartProp_lineColorLabel': 'Color de línea y símbolo',
	'lineColumnComboChartProp_symbolShapeLabel': 'Forma del símbolo',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Ocultar símbolos',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Ocultar símbolos',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Ocultar línea(s)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Ocultar línea(s)',
	'lineColumnComboChartProp_interpolationLabel': 'Líneas suavizadas',
	'lineColumnComboChartProp_interpolationDescription': 'Las líneas que conectan los puntos de datos son curvas.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Ocultar líneas de cuadrícula',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Ocultar líneas de cuadrícula',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Ocultar etiquetas de títulos de ejes',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Ocultar los títulos para los ejes.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Ocultar vacío',
	'lineColumnComboChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'lineColumnComboChartProp_hideLegendLabel': 'Ocultar leyenda',
	'lineColumnComboChartProp_hideLegendDescription': 'Ocultar la leyenda.',
	'lineColumnComboChartProp_legendPositionLabel': 'Posición de la leyenda',
	'summaryCaption': 'Resumen',
	'areaName': 'Área',
	'areaDescription': 'Área',
	'areaDataSlot_colorLabel': 'Aplicar color',
	'areaDataSlot_valuesLabel': 'Valor',
	'areaDataSlot_categoriesLabel': 'Etiqueta de eje',
	'bubbleName': 'Burbuja',
	'bubbleDescription': 'Burbuja',
	'bubbleDataSlot_yAxisLabel': 'Eje vertical',
	'bubbleDataSlot_xAxisLabel': 'Eje horizontal',
	'bubbleDataSlot_sizeLabel': 'Aplicar tamaño',
	'bubbleDataSlot_colorLabel': 'Aplicar color',
	'clusterBarName': 'Barra',
	'clusterBarDescription': 'Barra',
	'clusterBarDataSlot_colorLabel': 'Aplicar color',
	'clusterBarDataSlot_valuesLabel': 'Valor',
	'clusterBarDataSlot_categoriesLabel': 'Etiqueta de eje',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Valor',
	'clusterColumnName': 'Columna',
	'clusterColumnDescription': 'Columna',
	'clusterColumnDataSlot_colorLabel': 'Aplicar color',
	'clusterColumnDataSlot_valuesLabel': 'Valor',
	'clusterColumnDataSlot_categoriesLabel': 'Etiqueta de eje',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Valor',
	'clusterLineName': 'Línea',
	'clusterLineDescription': 'Línea',
	'clusterLineDataSlot_colorLabel': 'Aplicar color',
	'clusterLineDataSlot_valuesLabel': 'Eje vertical',
	'clusterLineDataSlot_categoriesLabel': 'Eje horizontal',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Valor',
	'gridName': 'Cuadrícula',
	'gridDescription': 'Cuadrícula',
	'gridDataSlot_grid_colsLabel': 'Columna',
	'heatName': 'Uso crítico',
	'heatDescription': 'Uso crítico',
	'heatDataSlot_yAxisLabel': 'Eje vertical',
	'heatDataSlot_xAxisLabel': 'Eje horizontal',
	'heatDataSlot_valuesLabel': 'Uso crítico por',
	'lineColumnComboName': 'Línea y columna',
	'lineColumnComboDescription': 'Línea y columna',
	'lineColumnComboDataSlot_lineValueLabel': 'Valor de línea',
	'lineColumnComboDataSlot_categoryLabel': 'Etiqueta de eje',
	'lineColumnComboDataSlot_columnValueLabel': 'Valor de columna',
	'mapName': 'Mapa heredado',
	'mapDescription': 'Mapa heredado',
	'mapDataSlot_sizeLabel': 'Tamaño de punto',
	'mapDataSlot_valuesLabel': 'Uso crítico de región',
	'mapDataSlot_sizeHeatLabel': 'Uso crítico de punto',
	'mapDataSlot_categoriesLabel': 'Regiones',
	'packedBubbleName': 'Burbuja empaquetada',
	'packedBubbleDescription': 'Burbuja empaquetada',
	'packedBubbleDataSlot_sizeLabel': 'Aplicar tamaño',
	'packedBubbleDataSlot_colorLabel': 'Aplicar color',
	'packedBubbleDataSlot_categoriesLabel': 'Categorías',
	'pieName': 'Circular',
	'pieDescription': 'Circular',
	'pieDataSlot_valuesLabel': 'Valor',
	'pieDataSlot_categoriesLabel': 'Categorías',
	'playerName': 'Reproductor de datos',
	'playerDescription': 'Reproductor de datos',
	'playerDataSlot_categoriesLabel': 'Etiqueta de eje',
	'pointName': 'Puntos',
	'pointDescription': 'Puntos',
	'pointDataSlot_colorLabel': 'Aplicar color',
	'pointDataSlot_valuesLabel': 'Valor',
	'pointDataSlot_categoriesLabel': 'Etiqueta de eje',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Valor',
	'radialDataSlot_maxSizeLabel': 'Valor máximo',
	'radialDataSlot_categoriesLabel': 'Categorías',
	'radialBarName': 'Barra radial',
	'radialBarDescription': 'Barra radial',
	'radialBarDataSlot_valuesLabel': 'Valor',
	'radialBarDataSlot_categoriesLabel': 'Categorías',
	'scatterPlotName': 'Diagrama de dispersión',
	'scatterPlotDescription': 'Diagrama de dispersión',
	'scatterPlotDataSlot_yAxisLabel': 'Eje vertical',
	'scatterPlotDataSlot_xAxisLabel': 'Eje horizontal',
	'scatterPlotDataSlot_colorLabel': 'Aplicar color',
	'scatterPlotDataSlot_categoriesLabel': 'Puntos',
	'stackedBarName': 'Apilar barra',
	'stackedBarDescription': 'Apilar barra',
	'stackedBarDataSlot_colorLabel': 'Aplicar color',
	'stackedBarDataSlot_valuesLabel': 'Valor',
	'stackedBarDataSlot_categoriesLabel': 'Etiqueta de eje',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Valor',
	'stackedColumnName': 'Apilar columna',
	'stackedColumnDescription': 'Apilar columna',
	'stackedColumnDataSlot_colorLabel': 'Aplicar color',
	'stackedColumnDataSlot_valuesLabel': 'Valor',
	'stackedColumnDataSlot_categoriesLabel': 'Etiqueta de eje',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Valor',
	'summaryChartName': 'Resumen',
	'summaryChartDescription': 'Resumen',
	'summaryChartDataSlot_valuesLabel': 'Valor',
	'treeMapName': 'Mapa de árbol',
	'treeMapDescription': 'Mapa de árbol',
	'treeMapDataSlot_colorLabel': 'Uso crítico por',
	'treeMapDataSlot_valuesLabel': 'Aplicar tamaño',
	'treeMapDataSlot_categoriesLabel': 'Nivel uno',
	'treeMapDataSlot_level3Label': 'Nivel tres',
	'treeMapDataSlot_level2Label': 'Nivel dos',
	'wordCloudName': 'Nube de palabras',
	'wordCloudDescription': 'Nube de palabras',
	'wordCloudDataSlot_colorLabel': 'Aplicar color',
	'wordCloudDataSlot_scaleLabel': 'Aplicar tamaño',
	'wordCloudDataSlot_wordLabel': 'Palabras',
	'treeMap1Cat1MeasureChartCaption': 'Mapa de árbol',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Nivel uno',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Aplicar tamaño',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de colores',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Ocultar vacío',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Ocultar leyenda',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Ocultar la leyenda.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Posición de la leyenda',
	'wordChart1Cat1MeasureCaption': 'Nube de palabras',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Palabras',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Aplicar tamaño',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Paletas de colores',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Color de palabras',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Mantener escala de eje',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Mostrar siempre los valores máximo y mínimo en los ejes.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Ocultar vacío',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Ocultar las categorías que no tienen valores asociados.',
	'missingDataSetData': 'Los datos para este conjunto de datos no están disponibles. Renueve el conjunto de datos o póngase en contacto con el administrador para acceder al origen.',
	'hideShowSummaries': 'Ocultar o mostrar resúmenes',
	'crosstabName': 'Tabla de referencias cruzadas',
	'value_is_not_available': 'N/D',
	'swapRowsAndColumns': 'Intercambiar filas y columnas',
	'NoPinsCollected': 'No hay visualizaciones ancladas',
	'pinSearchOld': 'Buscar mis chinchetas',
	'pinDeletedToast': 'Se ha eliminado la chincheta',
	'pinAddedToast': 'La chincheta se ha añadido correctamente a Mis chinchetas',
	'pinRetrieveError': 'No se pueden recuperar una o varias chinchetas. Vuelva a intentarlo más tarde.',
	'pinErrorTitle': 'Error al anclar',
	'pinRemove': 'Eliminar la chincheta',
	'deletePin': 'Suprimir la chincheta',
	'dataset_time': 'Hora',
	'dataset_date': 'fecha',
	'dataset_location': 'ubicación',
	'dataset_number': 'número',
	'dataset_text': 'texto',
	'widgetConditionalFormatLabel': 'Conmutar controles de formato condicional',
	'deletePinConfirmationMessage': '¿Está seguro de que desea suprimir esta chincheta? Esta acción no se puede deshacer.',
	'deletePinConfirm': 'Confirmar supresión',
	'pinDeleteError': 'No podemos suprimir una o varias chinchetas. Vuelva a intentarlo más tarde.',
	'metadataPickerTitle': 'Crear conjunto de datos',
	'moreTitle': 'Más',
	'remove_slider_handle': 'Eliminar descriptor de contexto',
	'missingFiltering': 'Falta columna:',
	'unSupportedPromptType': 'El escenario de solicitud no está soportado actualmente.',
	'preAggregateLabel': 'Aplicar valores de solicitud del origen de datos',
	'postAggregateLabel': 'Aplicar valores de solicitud en el informe',
	'preAggregateText': 'El rango utiliza los valores del origen de datos, no los valores mostrados en el panel de control.',
	'tabName_general': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Detalles',
	'tabName_textDetails': 'Detalles de texto', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Detalles del soporte multimedia', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Detalles de la página web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Detalles de la imagen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualización',
	'sectionName_canvas': 'Lienzo',
	'sectionName_colorsAndThemes': 'Color y tema',
	'colorsAndThemes_legacyWarning': 'El panel de control actual utiliza un tema de una versión anterior. Al cambiar el tema y guardar el panel de control de forma permanente, se elimina el acceso a las paletas del tema anterior.',
	'sectionName_details': 'Detalles',
	'sectionName_positionAndStyle': 'Posición y estilo',
	'sectionName_appearance': 'Aspecto', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Avanzado',
	'sectionName_layout': 'Diseño', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Pestañas',
	'sectionName_tabTitle': 'Etiqueta',
	'sectionName_tabBackground': 'Fondo',
	'addDataSourceDialogTitle': 'Añadir un origen de datos',
	'addDataSourceDialogButtonLabel': 'Añadir',
	'shapesDoubleChevron': 'Doble uve invertida',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelBasicsTab': 'Conceptos básicos',
	'widgetsPanelImageLibraryTab': 'Imágenes',
	'widgetsPanelSectionStandard': 'Estándar',
	'widgetsPanelSectionAdvanced': 'Avanzado',
	'widgetsPanelSectionShapes': 'Formas',
	'customWidgetsTitle': 'Widgets personalizados',
	'filterItemCanvasMove': 'Añadir al lienzo',
	'filterOverflowMenu_Global': 'Menú de desbordamiento Todas las pestañas',
	'filterOverflowMenu_Tab': 'Menú de desbordamiento Esta pestaña',
	'filterOverflowMenu_Item': 'Menú de desbordamiento Filtro',
	'filterOverflowMenu_Single': 'Menú de desbordamiento',
	'filterItemEdit': 'Editar valores de filtro',
	'filterDeleteAllItems': 'Suprimir todos los filtros',
	'filterClearAllItems': 'Borrar todos los filtros',
	'filterClearSelection': 'Borrar filtro',
	'filterPlayerMode': 'Visualizar reproductor',
	'filterStaticMode': 'Visualizar lista',
	'filterInvertSelection': 'Invertir filtro',
	'filterIconLabel_Global': 'Todas las pestañas',
	'filterIconLabel_Single': 'Filtros',
	'filterIconLabel_Tab': 'Esta pestaña',
	'filterIconTooltip_Global': 'Todas las pestañas',
	'filterIconTooltip_Tab': 'Esta pestaña',
	'filterIconTooltip_Single': 'Filtros',
	'filterItemDelete': 'Suprimir filtro',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'todo excepto: %{from}-%{to}',
	'filterExcept': 'excepto %{values}',
	'filterAll': 'Todo',
	'filterBlank': '(en blanco)',
	'filterDisableRangeInvert': 'No disponible cuando esta columna está en el filtro "Todas las pestañas".',
	'filterDisableHierarchyInvert': 'No disponible cuando esta columna está con un filtro de jerarquía.',
	'filterSelectedOfTotal': '%{selected} de %{totalMembers}',
	'filter_date_before': 'Antes de %{to}',
	'filter_date_before_except': 'No antes de %{to}',
	'filter_date_after': 'Después de %{from}',
	'filter_date_after_except': 'No después de %{from}',
	'filter_date_between': 'Entre %{from}-%{to}',
	'filter_date_between_except': 'No entre %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Arrastre y suelte los datos aquí para filtrar todas las pestañas.',
	'filter_drag_and_drop_current_tab': 'Arrastre y suelte los datos aquí para filtrar esta pestaña.',
	'filter_drag_and_drop_single_dock': 'Arrastre y suelte los datos aquí para filtrar.',
	'errMsgFilterItemGenericTitle': 'Los valores de filtro no pueden cargarse',
	'widgetChromeRotate': 'Rotar',
	'toolbarRegionLabel': 'Barra de herramientas',
	'toolbarActionDelete': 'Suprimir',
	'toolbarActionGroup': 'Agrupar',
	'toolbarActionUngroup': 'Desagrupar',
	'toolbarActionOrderToFront': 'Enviar delante',
	'toolbarActionOrderToBack': 'Enviar al fondo',
	'toolbarActionEditTitle': 'Editar el título',
	'toolbarActionWrapTitle': 'Ajustar el título',
	'toolbarActionPin': 'Recopilar',
	'toolbarActionPinOld': 'Anclar',
	'toolbarActionAlign': 'Alinear',
	'alignWidgetLeft': 'Izquierda',
	'alignWidgetCenter': 'Centro',
	'alignWidgetRight': 'Derecha',
	'alignWidgetTop': 'Superior',
	'alignWidgetMiddle': 'Centro',
	'alignWidgetBottom': 'Abajo',
	'toolbarChangeVisualization': 'Cambiar visualización',
	'multipurposeHeader': 'Seleccionar un tipo de widget',
	'multipurposePlaceholderText': 'Seleccione uno de los widgets para iniciar.',
	'live_label': 'Gráfico',
	'filter_label': 'Filtro',
	'one_named_live': 'Gráfico %{name}',
	'one_named_live_numbered': 'Gráfico %{name} (%{number})',
	'one_unknown_live': 'Gráfico',
	'one_unknown_live_numbered': 'Gráfico (%{number})',
	'few_live': 'Grupo de %{count} gráficos',
	'many_live': 'Grupo de %{count} gráficos',
	'one_custom': 'Widget personalizado',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtro %{name}',
	'one_named_filter_numbered': 'Filtro %{name} (%{number})',
	'one_unknown_filter': 'Filtro',
	'one_unknown_filter_numbered': 'Filtro (%{number})',
	'few_filter': 'Grupo de %{count} filtros',
	'many_filter': 'Grupo de %{count} filtros',
	'LIVE_bar_has_mapping': 'Gráfico de barras %{values}',
	'LIVE_bar_has_mapping_numbered': 'Gráfico de barras %{values} (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} por gráfico de barras %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Gráfico de barras %{categories} por %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Gráfico de barras vacío',
	'LIVE_bar_no_mapping_numbered': 'Gráfico de barras vacío (%{number})',
	'LIVE_bar_named': 'Gráfico de barras %{name}',
	'LIVE_bar_named_numbered': 'Gráfico de barras %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Gráfico de barras apiladas %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Gráfico de barras apiladas %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Gráfico de barras apiladas %{categories} por %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Gráfico de barras apiladas %{categories} por %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Gráfico de barras apiladas vacío',
	'LIVE_stacked_bar_no_mapping_numbered': 'Gráfico de barras apiladas vacío (%{number})',
	'LIVE_stacked_bar_named': 'Gráfico de barras apiladas %{name}',
	'LIVE_stacked_bar_named_numbered': 'Gráfico de barras apiladas %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Gráfico de burbujas %{categories} por %{x} y %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Gráfico de burbujas %{categories} por %{x} y %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Gráfico de burbujas vacío',
	'LIVE_bubble_no_mapping_numbered': 'Gráfico de burbujas vacío (%{number})',
	'LIVE_bubble_named': 'Gráfico de burbujas %{name}',
	'LIVE_bubble_named_numbered': 'Gráfico de burbujas %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Gráfico compuesto %{categories} por %{columnValue} y %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Gráfico compuesto %{categories} por %{columnValue} y %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Gráfico compuesto vacío',
	'LIVE_composite_no_mapping_numbered': 'Gráfico compuesto vacío (%{number})',
	'LIVE_composite_named': 'Gráfico compuesto %{name}',
	'LIVE_composite_named_numbered': 'Gráfico compuesto %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Árbol de decisiones %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Árbol de decisiones %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Árbol de decisiones vacío',
	'LIVE_decision_tree_no_mapping_numbered': 'Árbol de decisiones vacío (%{number})',
	'LIVE_decision_tree_named': 'Árbol de decisiones %{name}',
	'LIVE_decision_tree_named_numbered': 'Árbol de decisiones %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Gráfico de burbujas empaquetadas %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Gráfico de burbujas empaquetadas %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Gráfico de burbujas empaquetadas vacío',
	'LIVE_packed_bubble_no_mapping_numbered': 'Gráfico de burbujas empaquetadas vacío (%{number})',
	'LIVE_packed_bubble_named': 'Gráfico de burbujas empaquetadas %{name}',
	'LIVE_packed_bubble_named_numbered': 'Gráfico de burbujas empaquetadas %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Gráfico circular %{categories} por %{values}',
	'LIVE_pie_has_mapping_numbered': 'Gráfico circular %{categories} por %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Gráfico circular vacío',
	'LIVE_pie_no_mapping_numbered': 'Gráfico circular vacío (%{number})',
	'LIVE_pie_named': 'Gráfico circular %{name}',
	'LIVE_pie_named_numbered': 'Gráfico circular %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Gráfico de anillo %{categories} por %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Gráfico de anillo %{categories} por %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Gráfico en anillo vacío',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Gráfico de anillo vacío (%{number})',
	'LIVE_pie_as_donut_named': 'Gráfico de anillo %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Gráfico de anillo %{name} (%{number})',
	'LIVE_line_has_mapping': 'Gráfico de líneas %{categories} por %{values}',
	'LIVE_line_has_mapping_numbered': 'Gráfico de líneas %{categories} por %{values} (%{number})',
	'LIVE_line_no_mapping': 'Gráfico de líneas vacío',
	'LIVE_line_no_mapping_numbered': 'Gráfico de líneas vacío (%{number})',
	'LIVE_line_named': 'Gráfico de líneas %{name}',
	'LIVE_line_named_numbered': 'Gráfico de líneas %{name} (%{number})',
	'LIVE_area_has_mapping': 'Gráfico de áreas %{categories} por %{values}',
	'LIVE_area_has_mapping_numbered': 'Gráfico de áreas de %{categories} por %{values} (%{number})',
	'LIVE_area_no_mapping': 'Gráfico de áreas vacío',
	'LIVE_area_no_mapping_numbered': 'Gráfico de áreas vacío (%{number})',
	'LIVE_area_named': 'Gráfico de áreas %{name}',
	'LIVE_area_named_numbered': 'Gráfico de áreas %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Gráfico de áreas de porcentaje apiladas %{categories} por %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Gráfico de áreas de porcentaje apiladas %{categories} por %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Gráfico de áreas de porcentaje apiladas vacío',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Gráfico de áreas de porcentaje apiladas vacío (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Gráfico de áreas de porcentaje apiladas %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Gráfico de áreas de porcentaje apiladas %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Mapa de uso crítico %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Mapa de uso crítico %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Mapa de uso crítico vacío',
	'LIVE_heatmap_no_mapping_numbered': 'Mapa de uso crítico vacío (%{number})',
	'LIVE_heatmap_named': 'Mapa de uso crítico %{name}',
	'LIVE_heatmap_named_numbered': 'Mapa de uso crítico %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Red %{categories} por %{series} y %{values}',
	'LIVE_network_opt_mapping_numbered': 'Red %{categories} por %{series} y %{values} (%{number})',
	'LIVE_network_has_mapping': 'Red %{categories} por %{series}',
	'LIVE_network_has_mapping_numbered': 'Red %{categories} por %{series} (%{number})',
	'LIVE_network_no_mapping': 'Red vacía',
	'LIVE_network_no_mapping_numbered': 'Red vacía (%{number})',
	'LIVE_network_named': 'Red %{name}',
	'LIVE_network_named_numbered': 'Red %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Gráfico de barras radiales %{categories} por %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Gráfico de barras radiales %{categories} por %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Gráfico de barras radiales %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Gráfico de barras radiales %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Gráfico de barras radial vacío',
	'LIVE_radial_bar_no_mapping_numbered': 'Gráfico de barras radiales vacío (%{number})',
	'LIVE_radial_bar_named': 'Gráfico de barras radiales %{name}',
	'LIVE_radial_bar_named_numbered': 'Gráfico de barras radiales %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Gráfico de espiral %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Gráfico de espiral %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Gráfico en espiral vacío',
	'LIVE_spiral_no_mapping_numbered': 'Gráfico de espiral vacío (%{number})',
	'LIVE_spiral_named': 'Gráfico de espiral %{name}',
	'LIVE_spiral_named_numbered': 'Gráfico de espiral %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Mapa de árbol %{categories} por %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Mapa de árbol %{categories} por %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Mapa de árbol vacío',
	'LIVE_treemap_no_mapping_numbered': 'Mapa de árbol vacío (%{number})',
	'LIVE_treemap_named': 'Mapa de árbol %{name}',
	'LIVE_treemap_named_numbered': 'Mapa de árbol %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Nube de palabras %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Nube de palabras %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Nube de palabras vacía',
	'LIVE_wordcloud_no_mapping_numbered': 'Nube de palabras vacía (%{number})',
	'LIVE_wordcloud_named': 'Nube de palabras %{name}',
	'LIVE_wordcloud_named_numbered': 'Nube de palabras %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Reproductor de datos %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Reproductor de datos %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Reproductor de datos vacío',
	'LIVE_data_player_no_mapping_numbered': 'Reproductor de datos vacío (%{number})',
	'LIVE_data_player_named': 'Reproductor de datos %{name}',
	'LIVE_data_player_named_numbered': 'Reproductor de datos %{name} (%{number})',
	'LIVE_map_has_mapping': 'Mapa %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mapa %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Mapa vacío',
	'LIVE_map_no_mapping_numbered': 'Mapa vacío (%{number})',
	'LIVE_map_named': 'Mapa %{name}',
	'LIVE_map_named_numbered': 'Mapa %{name} (%{number})',
	'LIVE_point_has_mapping': 'Gráfico de puntos %{categories} por %{values}',
	'LIVE_point_has_mapping_numbered': 'Gráfico de puntos %{categories} por %{values} (%{number})',
	'LIVE_point_no_mapping': 'Gráfico de puntos vacío',
	'LIVE_point_no_mapping_numbered': 'Gráfico de puntos vacío (%{number})',
	'LIVE_point_named': 'Gráfico de puntos %{name}',
	'LIVE_point_named_numbered': 'Gráfico de puntos %{name} (%{number})',
	'LIVE_column_has_mapping': 'Gráfico de columnas %{values}',
	'LIVE_column_has_mapping_numbered': 'Gráfico de columnas %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Gráfico de columnas %{categories} por %{values}',
	'LIVE_column_opt_mapping_numbered': 'Gráfico de columnas %{categories} por %{values} (%{number})',
	'LIVE_column_no_mapping': 'Gráfico de columnas vacío',
	'LIVE_column_no_mapping_numbered': 'Gráfico de columnas vacío (%{number})',
	'LIVE_column_named': 'Gráfico de columnas %{name}',
	'LIVE_column_named_numbered': 'Gráfico de columnas %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Gráfico de columnas apiladas %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Gráfico de columnas apiladas %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Gráfico de columnas apiladas %{categories} por %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Gráfico de columnas apiladas %{categories} por %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Gráfico de columnas apiladas vacío',
	'LIVE_stacked_column_no_mapping_numbered': 'Gráfico de columnas apiladas (%{number})',
	'LIVE_stacked_column_named': 'Gráfico de columnas apiladas %{name}',
	'LIVE_stacked_column_named_numbered': 'Gráfico de columnas apiladas %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Diagrama de dispersión %{categories} por %{x} y %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Diagrama de dispersión %{categories} por %{x} y %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Diagrama de dispersión %{x} comparado con %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Diagrama de dispersión %{x} comparado con %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Diagrama de dispersión vacío',
	'LIVE_scatter_no_mapping_numbered': 'Diagrama de dispersión vacío (%{number})',
	'LIVE_scatter_named': 'Diagrama de dispersión %{name}',
	'LIVE_scatter_named_numbered': 'Diagrama de dispersión %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Gráfico de cascada %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Gráfico de cascada %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Gráfico de cascada vacío',
	'LIVE_waterfall_no_mapping_numbered': 'Gráfico de cascada vacío (%{number})',
	'LIVE_waterfall_named': 'Gráfico de cascada %{name}',
	'LIVE_waterfall_named_numbered': 'Gráfico de cascada %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Crear su visualización',
	'LIVE_empty_visualization_hint_description': 'Arrastre y suelte las columnas aquí o en las ranuras de la izquierda.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo necesario',
	'LIVE_slots_drag_and_drop_description': 'Arrastre y suelte los datos en las ranuras para crear y filtrar la visualización.',
	'requiredField': 'Campo necesario',
	'fullScreenEnter': 'Entrar en pantalla completa',
	'fullScreenClose': 'Salir de pantalla completa',
	'noExtraText_multipurpose': 'Marcador de posición de finalidad múltiple',
	'noExtraText_multipurpose_numbered': 'Marcador de posición de finalidad múltiple (%{number})',
	'one_placeholder_vis': 'Marcador de posición de visualización',
	'one_placeholder_vis_numbered': 'Marcador de posición de visualización (%{number})',
	'one_placeholder_text': 'Marcador de posición de texto',
	'one_placeholder_text_numbered': 'Marcador de posición de texto (%{number})',
	'few_placeholder_text': 'Grupo de marcadores de posición de texto %{count}',
	'many_placeholder_text': 'Grupo de marcadores de posición de texto %{count}',
	'filter_includesAll': 'Incluye todo',
	'timeline_filter_moved_to': 'El filtro de línea de tiempo %{id} se ha movido a %{time}',
	'timelineSettingsButton': 'Opciones de reproducción',
	'autoPlay': 'Reproducir todas las escenas',
	'loop': 'Bucle',
	'noSceneTransitionLabel': 'Ninguno',
	'sceneTransitionPropertyLabel': 'Transición de escena',
	'animatedPathSceneTransitionLabel': 'Ruta con animación',
	'sweepSceneTransitionLabel': 'Barrido',
	'propAniAnimation': 'Animación',
	'propAniTypeEntrance': 'Animación de entrada',
	'propAniDirectionIn': 'Dirección de entrada',
	'propAniTypeExit': 'Animación de salida',
	'propAniDirectionOut': 'Dirección de salida',
	'propAniDirection': 'Dirección',
	'timelineAnimationProperties': 'Abrir propiedades de animación',
	'editStoryCoachMarkTitle': 'Editar historia',
	'editStoryCoachMarkContents': 'Pulse el icono del lápiz para editar esta historia.',
	'addDataStoryCoachMarkContents': 'Arrastre los datos del panel de datos y suéltelos en la historia.',
	'expandSceneCoachmarkTitle': 'Abrir línea temporal',
	'expandSceneCoachmarkContents': 'Animar una escena ajustando la visibilidad del objeto en función del tiempo y la duración.',
	'overviewCoachmarkTitle': 'Escenas de descripción general',
	'overviewCoachmarkContents': 'Utilice las escenas de descripción general del principio y del final de la historia para tener una visión conjunta de todas las escenas. Desde una escena de descripción general, pulse una escena y arrástrela para intercambiarla por otra. Puede mostrar u ocultar las escenas de descripción general en las propiedades de la historia.',
	'animatedPathCoachmarkTitle': 'Ruta con animación',
	'animatedPathCoachmarkContents': 'Para dotar de animación a un objeto entre una escena y la siguiente, duplique una escena con un objeto. A continuación, mueva, cambie el tamaño o gire el objeto duplicado en la escena nueva.',
	'tabName_animation': 'Animación',
	'textWidgetIconPlaceholderText': 'Pulse para añadir texto',
	'buildVisHeader': 'Crear una visualización',
	'visIconPlaceholderText': 'Arrastre y suelte para crear una visualización',
	'launchNewExplore': 'Nueva exploración',
	'addTo': 'Añadir a',
	'addToExisting': 'Añadir a existente...',
	'exploreData': 'Explorar',
	'explore_remove_widget_styles': 'Las propiedades de visualización personalizadas, tales como los ajustes de color, no persistirán en su exploración.',
	'editNotebook': 'Editar widget',
	'thumbnails_error_fetching': 'Error al capturar miniaturas',
	'copy': '%{count} activo(s) copiado(s)',
	'specConvertErr': 'Se ha producido un error al pegar o convertir la especificación de panel de control',
	'specCopyErr': 'Error al copiar la especificación de panel de control',
	'pasteNotSupportedErr': 'No está soportado pegar desde un %{name}.',
	'reportParam': 'informe',
	'filterWidgetCopyWarn': 'No se ha copiado el filtrado de visualización porque los filtros no están soportados actualmente.',
	'upgradingDashboard': 'Actualizando "%{name}" para %{version}...',
	'upgradeComplete': 'Actualización completada',
	'individualTabProperties': 'Propiedades de pestaña individual',
	'propMasterTabStylesLabel': 'Estilo de pestaña maestra',
	'propTabPosition': 'Posición de pestaña',
	'propTabTitle': 'Título',
	'propTabBackgroundColor': 'Color de relleno',
	'propTabTextColor': 'Color del título',
	'propTabSelectedBarColor': 'Color de barra seleccionado',
	'propTabRestoreDefaults': 'Restaurar valores predeterminados',
	'propIndividualTabStylesLabel': 'Estilo de pestaña individual',
	'propIndividualTabStylesAriaLabel': 'Abrir propiedades de estilo de pestaña individual',
	'propTabIconPosition': 'Posición de icono',
	'propLeftTitle': 'Izquierda del título',
	'propRightTitle': 'Derecha del título',
	'propTopTitle': 'Encima del título',
	'propBottomTitle': 'Debajo del título',
	'propTabIconLabel': 'Visual',
	'propTabIcon': 'Icono',
	'propTabIconColor': 'Color del icono',
	'no_icon': 'Vacío',
	'announcement': 'Notificación',
	'api': 'Api',
	'archive': 'Archivar',
	'asset': 'Activo',
	'attachment': 'Archivo adjunto',
	'audio': 'Audio',
	'bee': 'Abeja',
	'blog': 'Blog',
	'bookmark': 'Marcador',
	'calendar': 'Calendario',
	'camera': 'Cámara',
	'capability': 'Capacidad',
	'catalog': 'Catálogo',
	'chat_message': 'Mensaje de chat',
	'checkout_cart': 'Tarjeta de extracción',
	'client': 'Cliente',
	'clock': 'Reloj',
	'cloud': 'Nube',
	'code': 'Código',
	'data_quality': 'Calidad de los datos',
	'folder': 'Carpetas',
	'forum': 'Foro',
	'glasses': 'Gafas',
	'group': 'Agrupar',
	'hat': 'Sombrero',
	'headphone': 'Auriculares',
	'hills': 'Montañas',
	'home': 'Inicio',
	'idea': 'Idea',
	'image': 'Imagen',
	'inventory': 'Inventario',
	'like': 'Igual',
	'link': 'Enlace',
	'location': 'Ubicación',
	'manage': 'Gestionar',
	'pen': 'Lápiz',
	'mobile_phone': 'Teléfono móvil',
	'music': 'Música',
	'notifications': 'Notificaciones',
	'paint': 'Dibujar',
	'payment': 'Pago',
	'password_key': 'Clave de contraseña',
	'people': 'Personas',
	'person': 'Persona',
	'phone': 'Teléfono',
	'pin': 'Anclar',
	'print': 'Imprimir',
	'recording': 'Grabación',
	'repository': 'Repositorio',
	'role': 'Rol',
	'search': 'Buscar',
	'properties': 'Propiedades',
	'speaker': 'Altavoz',
	'star': 'Estrella',
	'tag': 'Etiqueta',
	'thumbs_up': 'Pulgar arriba',
	'thumbs_down': 'Pulgar abajo',
	'tools': 'Herramientas',
	'traffic': 'Tráfico',
	'trash': 'Papelera',
	'twitter': 'Twitter',
	'unknown': 'Desconocido',
	'user': 'Usuario',
	'venn_diagram': 'Diagrama de Venn',
	'video': 'Vídeo',
	'view': 'Ver',
	'warning': 'Aviso',
	'watch': 'Reloj',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Espacio de trabajo',
	'world': 'Mundial',
	'OnLoadFilterModifierDatasourceMismatch': 'Los filtros no se aplicarán al destino porque los paneles de control están utilizando orígenes diferentes.',
	'OnLoadFilterModifierColumnMismatch': 'No se han aplicado uno o más filtros porque no se han podido encontrar las columnas coincidentes.',
	'eventGroupButtonLabel': 'Ver conexiones de widget',
	'dockToolbar': 'Acoplar barra de herramientas',
	'undockToolbar': 'Desacoplar barra de herramientas',
	'propShowTitle': 'Mostrar título'
});
